module.exports = __webpack_public_path__ + "img/04.45f34524.png";